<script>
	import { Router, Route } from "svelte-routing";
	import Home from "./routes/Home.svelte";
	import About from "./routes/About.svelte";
	import Login from "./routes/Login.svelte";
	import LoginConfirm from './routes/LoginConfirm.svelte';
	import Feed from "./routes/Feed.svelte";
	import AuthHome from "./routes/AuthHome.svelte";
	import AcceptInvite from "./routes/AcceptInvite.svelte";
	import SubscriptionEdition from "./routes/SubscriptionEdition.svelte";
	import feedStore from './stores/feed';

	!function(){var t,o,c,e=window,n=document,r=arguments,a="script",i=["call","cancelAction","config","identify","push","track","trackClick","trackForm","update","visit"],s=function(){var t,o=this,c=function(t){o[t]=function(){return o._e.push([t].concat(Array.prototype.slice.call(arguments,0))),o}};for(o._e=[],t=0;t<i.length;t++)c(i[t])};for(e.__woo=e.__woo||{},t=0;t<r.length;t++)e.__woo[r[t]]=e[r[t]]=e[r[t]]||new s;(o=n.createElement(a)).async=1,o.src="https://static.woopra.com/js/w.js",(c=n.getElementsByTagName(a)[0]).parentNode.insertBefore(o,c)}("woopra");

	woopra.config({
		domain: "evergreenfeeds.com",
		outgoing_tracking: true,
		download_tracking: true
	});

	woopra.track();

	export let url = "";

	$: isAuthenticated = $feedStore.isAuthenticated || window.localStorage.getItem('isAuthenticated')
</script>

<Router url="{url}">
	<div>
	  <Route path="/about" component="{About}" />
	  <Route path="/login" component="{Login}"/>
	  <Route path="/login-confirm" component="{LoginConfirm}" />
	  <Route path="/invite/:token/sub/:subscriptionID" let:params>
		<AcceptInvite token="{params.token}" subscriptionID="{params.subscriptionID}" />
	  </Route>
	  <Route path="/e/:editionUID" let:params>
	    <SubscriptionEdition editionUID="{params.editionUID}" />
	  </Route>
	  <Route path="/f/:feed_name" let:params> 
		<Feed feedName="{params.feed_name}" />
	  </Route>
	  <Route path="/*">
		{#if isAuthenticated}
			<AuthHome />
		{:else}
			<Home />
			<!-- <AuthHome /> -->
		{/if}
	  </Route>
	</div>
</Router>

<style>
	:global(body) {
        background-color: rgb(30,30,30);
		font-family: Lato;
    }

	:global(a) {
        text-decoration: none;
    }
</style>